var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublisherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 1.25H4.375L0.786458 1.50625C0.343403 1.53785 0 1.9066 0 2.35104V8.15313C0 8.64444 0.417014 9.03264 0.906945 8.99757L4.375 8.75L4.98368 8.74514L5.625 8.75L9.09306 8.99757C9.58333 9.03264 10 8.64444 10 8.15313V2.35104C10 1.90694 9.6566 1.53819 9.21354 1.5066L5.625 1.25ZM4.29583 7.64167L1.40451 7.84826C1.24583 7.85972 1.11111 7.73403 1.11111 7.575V2.85208C1.11111 2.70833 1.22222 2.58924 1.36563 2.57882L4.27674 2.37292C4.36736 2.36667 4.44444 2.43819 4.44444 2.52917V7.48542C4.44444 7.5684 4.37951 7.63646 4.29653 7.64167C4.29653 7.64167 4.29618 7.64167 4.29583 7.64167ZM8.59549 7.84826L5.70417 7.64167C5.70417 7.64167 5.70382 7.64167 5.70347 7.64167C5.62049 7.63611 5.55556 7.5684 5.55556 7.48542V2.52917C5.55556 2.43819 5.63264 2.36667 5.72326 2.37292L8.63438 2.57882C8.77778 2.58889 8.88889 2.70833 8.88889 2.85208V7.575C8.88889 7.73403 8.75417 7.85972 8.59549 7.84826Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublisherIcon);
export default __webpack_public_path__ + "static/media/PublisherIcon.6324336dd66427ca7a2a1aad8f236bf4.svg";
export { ForwardRef as ReactComponent };